import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { EmployeeTracking } from '@/components/employee/tracking';

const trackingSearchSchema = z.object({
  date: z.string().optional(), // YYYY-MM-DD
  from: z.string().optional(), // path to navigate back to (encoded)
});

export const Route = createFileRoute('/(app)/employee/tracking/')({
  component: EmployeeTrackingRoute,
  validateSearch: trackingSearchSchema,
});

function EmployeeTrackingRoute() {
  // Own view: bracket the day to the iOS attendance-day window. The manager
  // route ($employeeId) does NOT pass this -- its pipeline is untouched.
  return (
    <EmployeeTracking
      showBackButton={false}
      applyAttendanceWindow
    />
  );
}
